const USER_ACTIVE_STATUSES = new Set(["DRAFT", "SUBMITTED", "IN_CLARIFY", "IN_REVIEW"]);
const USER_FINISHED_STATUSES = new Set(["APPROVED", "REJECTED"]);

const REVIEWABLE_STATUSES = new Set(["SUBMITTED", "IN_REVIEW", "CLARIFIED"]);
const REVIEW_FINISHED_STATUSES = new Set(["APPROVED", "REJECTED"]);

function sortByUpdatedAtDesc(rows = []) {
  return rows
    .slice()
    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
}

export function filterSubmissionsByStatus(rows = [], statusFilter = "ALL") {
  if (statusFilter === "ALL") {
    return rows;
  }

  return rows.filter((submission) => submission?.status === statusFilter);
}

export function partitionMySubmissions(submissions = []) {
  return {
    activeSubmissions: sortByUpdatedAtDesc(
      submissions.filter((submission) => USER_ACTIVE_STATUSES.has(submission?.status))
    ),
    finishedSubmissions: sortByUpdatedAtDesc(
      submissions.filter((submission) => USER_FINISHED_STATUSES.has(submission?.status))
    ),
  };
}

function hasAssignedReviewers(submission) {
  return (
    Array.isArray(submission?.reviewedBy) &&
    submission.reviewedBy.filter(Boolean).length > 0
  );
}

function isAssignedToCurrentUser(submission, currentUserId) {
  if (!Array.isArray(submission?.reviewedBy) || !currentUserId) {
    return false;
  }

  return submission.reviewedBy.map(String).includes(String(currentUserId));
}

export function partitionReviewerSubmissions(submissions = [], currentUserId) {
  const reviewable = submissions.filter((submission) =>
    REVIEWABLE_STATUSES.has(submission?.status)
  );

  return {
    waitingSubmissions: sortByUpdatedAtDesc(
      reviewable.filter((submission) => !hasAssignedReviewers(submission))
    ),
    assignedSubmissions: sortByUpdatedAtDesc(
      reviewable.filter(
        (submission) =>
          hasAssignedReviewers(submission) &&
          !isAssignedToCurrentUser(submission, currentUserId)
      )
    ),
    assignedToMeSubmissions: sortByUpdatedAtDesc(
      reviewable.filter(
        (submission) =>
          hasAssignedReviewers(submission) &&
          isAssignedToCurrentUser(submission, currentUserId)
      )
    ),
    finishedSubmissions: sortByUpdatedAtDesc(
      submissions.filter((submission) => REVIEW_FINISHED_STATUSES.has(submission?.status))
    ),
  };
}
